import React, {useEffect, createRef} from 'react';
import { 
        CheckBoxContainer, 
        CheckBoxLabel, 
        CheckBoxShowOptionSelectedMessageError
      } from './styles';

const CheckBox = ({ error, name, id, label, disabled, defaultValue, register, onChange}) => {
  const ref = createRef();
  return (
    <CheckBoxContainer id={`checkBox${name}`} ref={ref}>
      
      <input type="checkbox" name={name} id={id} defaultValue={defaultValue} ref={register} disabled={disabled} onChange={onChange}/>
      <CheckBoxLabel>{label}</CheckBoxLabel>
            {error && <CheckBoxShowOptionSelectedMessageError error={error}>{error.message}</CheckBoxShowOptionSelectedMessageError>}
      
    </CheckBoxContainer>
  )
}

export default CheckBox
